import * as S from './buttons.styles'
import { LegacyLeftArrowIcon } from '../../../icons'
import { useNavigate } from 'react-router'
import { PHOTO_STYLER_URL } from 'config/config'

type Props = {
  onClick?: () => void
}

export default function BackButton({ onClick }: Props) {
  const navigate = useNavigate()

  function handleClick() {
    if (onClick) {
      onClick()
    } else if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate(PHOTO_STYLER_URL)
    }
  }

  return (
    <S.Clickable onClick={handleClick}>
      <LegacyLeftArrowIcon />
    </S.Clickable>
  )
}
